import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { initPwa } from "./lib/pwa";
import { router } from "./router";
import { CalculatorProvider } from "./state/calculator";
import { FeeDataProvider } from "./state/fee-data";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./styles.css";

initPwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <FeeDataProvider>
        <CalculatorProvider>
          <RouterProvider router={router} />
        </CalculatorProvider>
      </FeeDataProvider>
    </ThemeProvider>
  </StrictMode>,
);
